export default __webpack_public_path__ + "static/media/GoodMannersOnThePhone_05.055410fd.png";